export type AccountType = 'private' | 'business';

export interface RegisterFormFields {
  type: AccountType;
  first_name: string;
  last_name: string;
  email: string;
  new_password: string;
  phone: string;
  termsofuse: boolean;
  account_name: string;
  address_line1: string;
  postal_code: string;
  locality: string;
  country_code: string;
}

export function buildRegisterSubmitPayload(values: RegisterFormFields): {
  user: Record<string, unknown>;
} {
  const base = {
    type: values.type,
    first_name: values.first_name,
    last_name: values.last_name,
    email: values.email,
    phone: values.phone,
    new_password: values.new_password,
    termsofuse: values.termsofuse,
  };
  if (values.type === 'business') {
    return {
      user: {
        ...base,
        account: {
          name: values.account_name,
          address: {
            line1: values.address_line1,
            postal_code: values.postal_code,
            locality: values.locality,
            country_code: values.country_code,
          },
        },
      },
    };
  }
  return { user: base };
}
